import { Carousel } from "@gift/ui";
import styled from "styled-components";

export const StyledCarousel = styled(Carousel)`
    box-shadow: 0 0 5px ${({ theme }) => theme.colors.grayLight};
`;
